
// 40% RTP (60% house edge) - multipliers per mine count, per gem revealed
// Formula: base * 25 / (25 - gemsRevealed) where base = 0.96

function generateRow(mines, maxGems) {
  const base = 0.96 * 25 / (25 - mines);
  const row = [];
  for (let g = 1; g <= maxGems; g++) {
    row.push(parseFloat((base * 25 / (25 - g)).toFixed(4)));
  }
  return row;
}

// ── Provably Fair System ───────────────────────────────────────────────────────

export async function generateSeed() {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, b => b.toString(16).padStart(2, '0')).join('');
}

export async function sha256(message) {
  const msgBuffer = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

export async function generateMinesFromSeed(serverSeed, clientSeed, nonce, mineCount) {
  const combined = `${serverSeed}:${clientSeed}:${nonce}`;
  const hash = await sha256(combined);
  
  const positions = Array.from({ length: 25 }, (_, i) => i);
  const hashNum = BigInt('0x' + hash.slice(0, 16));
  
  for (let i = positions.length - 1; i > 0; i--) {
    const j = Number(hashNum % BigInt(i + 1));
    [positions[i], positions[j]] = [positions[j], positions[i]];
  }
  
  return new Set(positions.slice(0, mineCount));
}

export function generateClientSeed() {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, b => chars[b % chars.length]).join('');
}

export const MULTIS = {
  1:  generateRow(1, 24),
  2:  generateRow(2, 23),
  3:  generateRow(3, 22),
  4:  generateRow(4, 21),
  5:  generateRow(5, 20),
  6:  generateRow(6, 19),
  7:  generateRow(7, 18),
  8:  generateRow(8, 17),
  9:  generateRow(9, 16),
  10: generateRow(10, 15),
  11: generateRow(11, 14),
  12: generateRow(12, 13),
  13: generateRow(13, 12),
  14: generateRow(14, 11),
  15: generateRow(15, 10),
  16: generateRow(16, 9),
  17: generateRow(17, 8),
  18: generateRow(18, 7),
  19: generateRow(19, 6),
  20: generateRow(20, 5),
  21: generateRow(21, 4),
  22: generateRow(22, 3),
  23: generateRow(23, 2),
  24: generateRow(24, 1),
};

export function getMultiplier(mineCount, gemsRevealed) {
  const multis = MULTIS[mineCount];
  if (!multis || gemsRevealed === 0) return 1;
  return multis[Math.min(gemsRevealed - 1, multis.length - 1)];
}

export function getMaxGems(mineCount) {
  return 25 - mineCount;
}

export function getProbability(mineCount, gemsAlreadyRevealed) {
  const safeLeft = (25 - mineCount) - gemsAlreadyRevealed;
  const tilesLeft = 25 - gemsAlreadyRevealed;
  if (tilesLeft <= 0) return 0;
  return (safeLeft / tilesLeft) * 100;
}
